import useLocaleText from 'components/useLocaleText'

export const categoryContentLiterals = {
  chooseCategory: {
    key: 'task_creation_choose_category',
    fallback: { en: 'Choose categories', he: 'בחירת קטגוריות' },
  },
  categoryHint: {
    key: 'task_creation_category_first_hint',
    fallback: {
      en: 'A category groups subtasks — e.g. one per store zone. Pick one or several.',
      he: 'קטגוריה מקבצת תתי־משימות, למשל לפי אזור בחנות. בחרו אחת או יותר.',
    },
  },
  addSubtasks: {
    key: 'task_creation_add_subtasks_each_category',
    fallback: { en: 'Add subtasks to each category', he: 'הוספת תתי־משימות לכל קטגוריה' },
  },
  categories: { key: 'categories', fallback: { en: 'Categories', he: 'קטגוריות' } },
  addCategory: { key: 'add_category', fallback: { en: 'Add category', he: 'הוספת קטגוריה' } },
  deleteCategory: { key: 'delete_category', fallback: { en: 'Delete category', he: 'מחיקת קטגוריה' } },
  subtasks: { key: 'subtasks', fallback: { en: 'subtasks', he: 'תתי־משימות' } },
  addingTo: {
    key: 'task_creation_category_adding_to',
    fallback: { en: 'Adding to', he: 'תתי־משימות חדשות יתווספו לקטגוריה' },
  },
  orderHint: {
    key: 'task_creation_category_order_hint',
    fallback: { en: 'Drag to reorder within each category.', he: 'גררו כדי לשנות את הסדר בתוך כל קטגוריה.' },
  },
  needCategory: {
    key: 'add_cat_err',
    fallback: { en: 'Add a category to organize this task.', he: 'הוסיפו קטגוריה כדי לארגן את המשימה.' },
  },
  needSubtask: {
    key: 't_add_subtasks_empty_screen',
    fallback: { en: 'Add a subtask to', he: 'הוסיפו תת־משימה לקטגוריה' },
  },
  restored: { key: 'draft', fallback: { en: 'Saved draft restored', he: 'הטיוטה השמורה שוחזרה' } },
  dismiss: { key: 'close', fallback: { en: 'Dismiss', he: 'סגירה' } },
}

// Missing new helper-copy keys; existing field/error labels use their original catalog entries.
export const missingCategoryContentLiteralKeys = [
  categoryContentLiterals.chooseCategory.key,
  categoryContentLiterals.categoryHint.key,
  categoryContentLiterals.addingTo.key,
  categoryContentLiterals.orderHint.key,
]
export const useCategoryContentText = () => useLocaleText(categoryContentLiterals)
